var fails = require('../internals/fails');

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  return Object.getPrototypeOf(new F()) !== F.prototype;
});



// WEBPACK FOOTER //
// webpack:///node_modules/core-js/internals/correct-prototype-getter.js